export const AUTHENTICATED: string = "authenticated_user";
export const UNAUTHENTICATED: string = "unauthenticated_user";
export const REQUEST_LOGOUT: string = "logout_request";
export const SET_USER_ROLE: string = "set_user_role";
export const SET_USER: string = "set_user";
